import React, {useState} from 'react';
import {Col, Row} from "reactstrap";
import {
    CURRENCY_HEADER,
    DISCOUNT_HEADER, LAST_UPDATE_HEADER, MANUALLY_ASSIGNED,
    NO_DATA_FOUND,
    PREBUY_HEADER,
    PRICE_HEADER,
    SAVINGS_HEADER
} from "../i18n/i18n";

export default function ProductPriceElement(props) {
    const [row] = useState(props.row);

    // Formats date from 2025-10-30T05:31:25Z to 30/10/2025 05:31:25
    const formatDate = (stringDate) => {
        const date = new Date(stringDate);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    return (
        <div className={"prices-table"}>
            {
                row?.paxes?.length > 0 ?
                    <Row >
                        <Col md={"12"} >
                            <Row>
                                <Col md={"2"} >
                                </Col>
                                <Col md={"2"} >
                                    <h4>{LAST_UPDATE_HEADER}</h4>
                                </Col>
                                <Col md={"1"} >
                                    <h4>{CURRENCY_HEADER}</h4>
                                </Col>
                                <Col md={"2"} >
                                    <h4>{PRICE_HEADER}</h4>
                                </Col>
                                <Col md={"2"} >
                                    <h4>{DISCOUNT_HEADER}</h4>
                                </Col>
                                <Col md={"1"} >
                                    <h4>{SAVINGS_HEADER}</h4>
                                </Col>
                                <Col md={"1"} >
                                    <h4>{PREBUY_HEADER}</h4>
                                </Col>
                                <Col md={"1"} >
                                    <h4>{MANUALLY_ASSIGNED}</h4>
                                </Col>
                            </Row>
                        </Col>
                    </Row> : <h4>{NO_DATA_FOUND}</h4>
            }
            {
                row?.paxes?.length > 0 ?
                    row?.paxes?.map((pax, indexPax) => {
                    return (
                    <Row className={"prices-table-row"} key={"pax" + indexPax }>
                        <Col md={"12"} >
                        {
                            pax?.prices?.length > 0 ?
                                pax?.prices?.map((price, indexPrices) => {
                                    return (
                                        <Row key={"pax" + indexPax + "price" + indexPrices}>
                                            <Col md={"2"} >
                                                <p>{price.uid}</p>
                                            </Col>
                                            <Col md={"2"} >
                                                <p>{ formatDate( price.last_update ) }</p>
                                            </Col>
                                            <Col md={"1"} >
                                                <p>{price.currency}</p>
                                            </Col>
                                            <Col md={"2"} >
                                                <p>{"$ " + price.price}</p>
                                            </Col>
                                            <Col md={"2"} >
                                                <p>{"$ " + price.price_discount}</p>
                                            </Col>
                                            <Col md={"1"} >
                                                <p>{"$ " + price.saving}</p>
                                            </Col>
                                            <Col md={"1"} >
                                                <p>{"% " + price.pre_buy_discount}</p>
                                            </Col>
                                            <Col md={"1"} >
                                                <p className='text-center'>{ price?.priceManuallyAssigned && <span  className="fas fa-check"/> }</p>
                                            </Col>
                                        </Row>
                                    );
                                }) : null
                        }
                        </Col>
                    </Row>
                    );
                }) : null
            }
        </div>
    )
}